import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const DashBoard = ({ children }) => {
  return (
    <div className="dashboard-layout">
      <Header />
      <main className="dashboard-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
export default DashBoard;
